import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface NoReportsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const NoReportsIcon = ({ className, ...props }: NoReportsIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    viewBox="0 0 125 120"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M111.842 20.5554H14.8767C13.5687 20.5564 12.3142 21.0765 11.3891 22.0012C10.464 22.9263 9.94432 24.1808 9.94336 25.4888V114.455C9.94432 115.763 10.464 117.018 11.3891 117.943C12.3142 118.867 13.5687 119.388 14.8767 119.389H111.842C113.15 119.388 114.404 118.868 115.329 117.943C116.254 117.018 116.774 115.763 116.775 114.455V25.4888C116.774 24.1808 116.254 22.9263 115.329 22.0012C114.404 21.0761 113.15 20.5564 111.842 20.5554Z"
      fill="#C6C6C6"
    />
    <path
      d="M105.459 88.473H21.2615C18.5369 88.473 16.3281 86.2642 16.3281 83.5396V4.93339C16.3281 2.20877 18.5369 0 21.2615 0H105.459C108.183 0 110.392 2.20877 110.392 4.93339V83.5396C110.392 86.2642 108.183 88.473 105.459 88.473Z"
      fill="#F3F3F3"
    />
    <path
      d="M95.0982 16.6083H31.6211V20.226H95.0982V16.6083ZM95.0982 30.4212H31.6211V34.0389H95.0982V30.4212ZM95.0982 44.2374H31.6211V47.8547H95.0982V44.2374ZM95.0982 58.0504H31.6211V61.668H95.0982V58.0504Z"
      fill="white"
    />
    <path
      d="M39.1855 46.374L55.1365 62.3254H39.1855V46.374Z"
      fill="url(#paint0_linear_2981_166289)"
    />
    <path
      d="M116.775 63.6412V26.9398L110.391 20.5554V63.6407H116.775V63.6412Z"
      fill="#C6C6C6"
    />
    <path
      d="M124.254 66.9609L117.375 115.649C117.032 118.083 114.949 119.892 112.49 119.892H14.229C11.7711 119.892 9.68809 118.083 9.34435 115.649L0.0493672 49.8597C-0.369916 46.8893 1.93495 44.236 4.93447 44.236H35.2796C37.7375 44.236 39.821 46.045 40.1647 48.4785L41.3829 57.0941C41.7267 59.5281 43.8097 61.3372 46.2675 61.3372H119.37C122.368 61.3372 124.673 63.991 124.254 66.9609H124.254Z"
      fill="url(#paint1_linear_2981_166289)"
    />
    <path
      d="M99.8835 98.1753H26.836C26.4354 98.1748 26.0491 98.029 25.7484 97.7641C25.4481 97.4992 25.2545 97.134 25.2043 96.7372L24.2902 89.5008C24.261 89.2694 24.2816 89.0347 24.3505 88.8114C24.4193 88.5886 24.5345 88.3826 24.6889 88.2076C24.8429 88.0326 25.0327 87.8925 25.2454 87.7964C25.4582 87.7004 25.6886 87.6506 25.9219 87.6506H100.798C101.031 87.6506 101.261 87.7004 101.474 87.7964C101.687 87.8925 101.876 88.0326 102.031 88.2076C102.185 88.3826 102.3 88.5886 102.369 88.8114C102.438 89.0347 102.458 89.2694 102.429 89.5008L101.515 96.7372C101.465 97.134 101.271 97.4992 100.971 97.7641C100.67 98.029 100.284 98.1748 99.8835 98.1753Z"
      fill="#D5D5D5"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2981_166289"
        x1="49.7224"
        x2="30.442"
        y1="64.8863"
        y2="45.6065"
      >
        <stop
          offset="0"
          stopColor="#CEC2C2"
          stopOpacity="0"
        />
        <stop
          offset="0.179"
          stopColor="#BCAFAF"
          stopOpacity="0.179"
        />
        <stop
          offset="1"
          stopColor="#6A5B5C"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2981_166289"
        x1="62.1518"
        x2="62.1518"
        y1="44.236"
        y2="119.892"
      >
        <stop stopColor="#F2F3F3" />
        <stop
          offset="0.927"
          stopColor="#E4E4E4"
        />
      </linearGradient>
    </defs>
  </svg>
);

export default NoReportsIcon;
